import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { JsonInput, PtlWindowLocationService } from '@ptl/global-components';

/** They just come from the implementation, but are not relevant for now */
interface ignorableAEMFields {
  "cq:lastRolledout": string; // "Mon Jul 28 2025 17:17:59 GMT-0400"
  "cq:lastRolledoutBy": string; // "msm-service"
  "jcr:mixinTypes": string[]; // ['cq:LiveRelationship']
}
interface SpecialEnrollmentEventSelectorCardInterface extends ignorableAEMFields {
  content: string; // "<b>Your situation:<b><br/>This could be you if you or anyone in your household lost qualifying health coverage or you expect to lose coverage"
  fileReference_cardThumbnail: string; // "/content/dam/image1.jpg"
  imgAltText: string; // "alt text"
  selectNavUrl: string; // "/build-your-family/special-enrollment-qualification-events/loss-of-essential-minimum-coverage"
  title: string; // "Loss of Essential Minimum Coverage"
  id: number; // this is generated in the SXEAMS config.js file associate w/ this component
}
@Component({
  selector: 'app-special-enrollment-event-selector-cards',
  templateUrl: './special-enrollment-event-selector-cards.component.html',
  styleUrl: './special-enrollment-event-selector-cards.component.scss',
  standalone: false
})
export class SpecialEnrollmentEventSelectorCardsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() @JsonInput() sepObjects: SpecialEnrollmentEventSelectorCardInterface[];

  constructor(
    private windowLocationService: PtlWindowLocationService
  ) { }

  async ngOnInit(): Promise<void> {
    console.log(this.sepObjects);
  }

  ngAfterViewInit(): void {
  }
  ngOnDestroy(): void {
  }
  public navigate(urlPath: string): void {
    if (urlPath) {
      this.windowLocationService.goToUrl(urlPath);
    } else {
      console.warn("Missing url for nav");
    }
  }


}
